export type ScanInventoryType = 'd365' | 'pms'

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export function inferScanTypeFromCode(code: string): ScanInventoryType {
  return UUID_RE.test(code.trim()) ? 'pms' : 'd365'
}
